import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProgramSection from './components/ProgramSection';
import CoreValuesSection from './components/CoreValuesSection';
import FacilityCarousel from './components/FacilityCarousel';
import AmenitiesSection from './components/AmenitiesSection';
import LessonSection from './components/LessonSection';
import ProSection from './components/ProSection';
import LocationSection from './components/LocationSection';
import CtaSection from './components/CtaSection';
import { facilityImages, amenityImages, galleryImages } from '@/mocks/homeData';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <section className="h-16 bg-white" />
        <HeroSection />
        <AboutSection />
        <ProgramSection />
        <CoreValuesSection />
        <AmenitiesSection />
        <FacilityCarousel images={galleryImages} slidesToShow={4} autoplayInterval={5000} />
        <LessonSection />
        <ProSection />
        <LocationSection />
        <CtaSection />
      </main>
    </div>
  );
}